import { Component, EventEmitter, Output } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { AiGenerationMode } from '../../../constants/ai-modes.constants';

@Component({
    selector: 'app-ai-mode-step',
    templateUrl: './ai-mode-step.component.html',
    styleUrls: ['./ai-mode-step.component.scss'],
    standalone: false
})
export class AiModeStepComponent {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  AiGenerationMode = AiGenerationMode;

  constructor(
    private stateService: WizardStateService
  ) {}

  selectMode(mode: AiGenerationMode): void {
    if (mode === AiGenerationMode.Manual) {
      // Set aiMode first so engine knows to go to ManualConfirm (Step 5a)
      this.stateService.updateState({ aiMode: AiGenerationMode.Manual });
      this.next.emit();
    } else {
      // AI Assisted or Guided goes straight to next step
      this.stateService.updateState({ aiMode: mode });
      this.next.emit();
    }
  }

  onBack(): void {
    this.back.emit();
  }
}
